import * as XLSX from 'xlsx';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { getDefName } from '../../constants';

export const exportExcel = ({ jsonData, type, languages = [], types = [], hospitals = [] }) => {
  if (!jsonData || !jsonData.length) return;

  const getLangName = (id) => {
    const lang = languages.find((l) => l.id === id);
    return lang ? lang[getDefName()] : id;
  };

  const getTypeName = (id) => {
    const type = types.find((t) => t.id === id);
    return type ? type[getDefName()] : id;
  };

  const getHosName = (id) => {
    const _hos = hospitals.find((hos) => hos.id === id);
    return _hos ? _hos['name_ko'] : '';
  };

  let exportData = [];

  if (type === 'Hospital') {
    exportData = jsonData.map((item) => ({
      Id: item.id || '',
      'Hospital Name(Kor)': item.name_ko || '',
      'Hospital Name': item.name_en || '',
      Language: getLangName(item.languageId),
      Category: getTypeName(item.typeId),
      'Show / Hide': item.hidden === true ? 'Hide' : 'Show',
      'Registration time': item.createdAt ? moment(Number(item.createdAt)).format('YYYY-MM-DD HH:mm') : '',
      'View Count': item.viewCnt ?? 0,
    }));
  }

  if (type === 'Doctor') {
    exportData = jsonData.map((item) => ({
      Id: item.id || '',
      'Name(Kor)': item.name_ko || '',
      Name: item.name_en || '',
      Language: getLangName(item.languageId),
      'Hospital Name': getHosName(item.hospitalId),
      Writer: item.writerId || '',
      'Show / Hide': item.hidden === true ? 'Hide' : 'Show',
      'Registration time': item.createdAt ? moment(Number(item.createdAt)).format('YYYY-MM-DD HH:mm') : '',
      'View Count': item.viewCnt ?? 0,
    }));
  }

  if (type === 'Product') {
    exportData = jsonData.map((item) => ({
      Id: item.id || '',
      'Product Name': item.name_ko || '',
      Language: getLangName(item.languageId),
      Category: getTypeName(item.typeId),
      'Hospital Name': getHosName(item.hospitalId),
      Writer: item.writerId || '',
      'Show / Hide': item.hidden === true ? 'Hide' : 'Show',
      'Registration time': item.createdAt ? moment(Number(item.createdAt)).format('YYYY-MM-DD HH:mm') : '',
      'View Count': item.viewCnt ?? 0,
    }));
  }

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, type || 'Export');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const fileName = `${type}_list_${moment().format('YYYYMMDD_HHmm')}.xlsx`;
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, fileName);
};
